module.exports = __webpack_public_path__ + "img/ymi.f547bc91.png";